var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNerolidol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#A41782;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.4,353.2h6.4l14.8,22.3h0.1v-22.3h6.5v33h-6.6L123,364.4H123v21.8h-6.5V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.5,353.2h21.1v5.8h-14.7v8h11.7v5.7h-11.7v7.7h15.6v5.8h-22.1V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.3,353.2h12.5c8,0,11.5,4.7,11.5,11c0,5-2.3,8.5-6.9,10l8.3,12.1h-7.8l-7.4-11.3h-3.8v11.3h-6.5V353.2z  M190.5,369.2c4,0,6-2,6-5.1c0-3.1-2-5.1-5.8-5.1h-5v10.1H190.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.3,369.7c0-9.8,6.8-16.9,16.8-16.9c9.7,0,16.8,6.8,16.8,16.9c0,10-7.1,16.9-16.8,16.9 C214.1,386.6,207.3,379.5,207.3,369.7z M234.1,369.7c0-6.2-4.3-10.8-10-10.8c-6,0-10,4.8-10,10.8c0,6,4.1,10.8,10,10.8 C229.8,380.5,234.1,375.9,234.1,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.7,353.2h6.7v27.2H268v5.8h-21.3V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.2,353.2h6.7v33h-6.7V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.2,353.2h10.9c10.5,0,17.2,6.8,17.2,16.6c0,9.7-6.4,16.5-17,16.5h-11.1V353.2z M297.9,380.4 c6.4,0,10.6-4.6,10.6-10.7c0-6.2-4.2-10.7-10.2-10.7h-4.6v21.4H297.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.7,369.7c0-9.8,6.8-16.9,16.8-16.9c9.7,0,16.8,6.8,16.8,16.9c0,10-7.1,16.9-16.8,16.9 C326.6,386.6,319.7,379.5,319.7,369.7z M346.5,369.7c0-6.2-4.3-10.8-10-10.8c-6,0-10,4.8-10,10.8c0,6,4.1,10.8,10,10.8 C342.3,380.5,346.5,375.9,346.5,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.2,353.2h6.7v27.2h14.6v5.8h-21.3V353.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.1,152.6h-4.6v38.7h5.2c2.3,0,3.5-2.3,3.5-6.8v-24.7c0-2.5-0.4-4.3-1.1-5.5 C258.2,153.2,257.2,152.6,256.1,152.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.6,98.8c-54.4,0-98.4,44.1-98.4,98.4s44.1,98.4,98.4,98.4s98.4-44.1,98.4-98.4S302,98.8,247.6,98.8z  M231.1,245.3h-11l-13.2-70.9h-0.1v70.9h-8.2V144.4h11.1l12.4,69.9v-69.9h9.1v100.9H231.1z M261.7,245.3c-0.7-1.1-1.1-3.1-1.3-5.8 c-0.2-2.7-0.3-6.5-0.3-11.4v-22.7c0-4.6-1.1-6.9-3.5-6.9h-5.2v46.8h-9.8V144.4H257c3.5,0,6.5,1.2,9,3.5c2.6,2.4,3.8,5.8,3.8,10.5 v26.7c0,3.1-0.5,5.4-1.4,6.9c-1,1.5-2.2,2.5-3.6,3c1.4,0.4,2.6,1.3,3.6,2.8s1.4,3.8,1.4,6.8v23.5c0,6.1,0.2,10.3,0.6,12.8 s0.7,3.9,1,4.4L261.7,245.3L261.7,245.3z M303.4,245.3h-21.9V144.4h9.8v93.5h12.1V245.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNerolidol);
export default __webpack_public_path__ + "static/media/NEROLIDOL.8d4ba2954c033690a25b3a56ee1f8de5.svg";
export { ForwardRef as ReactComponent };